module.exports = __webpack_public_path__ + "img/blank_profile_big.fcac7047.svg";